export default __webpack_public_path__ + "static/media/japan.eda24f84.png";